import { LastThingEvent } from '@eagle/core-data-types';
import { Operator } from '@jexop/core';
import { getThingEventServerTime } from '../components';

export const lastEventTime: Operator = (_, { lastThingEvent }) => {
  if (!lastThingEvent) return null;

  return getThingEventServerTime(lastThingEvent as LastThingEvent);
};
